// extracted by mini-css-extract-plugin
export default {"doctors-list":"AdminDoctorList_doctors-list__NFoPt","DoctorslistContainer":"AdminDoctorList_DoctorslistContainer__5kvTy","loader":"AdminDoctorList_loader__InmSx"};